import Icon from '../components/Icon.vue'

Icon.register({
  'network-wired': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M640 264c0 8.8-7.2 16-16 16h-104v40h56c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-160c-17.7 0-32-14.3-32-32v-128c0-17.7 14.3-32 32-32h56v-40h-304v40h56c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-160c-17.7 0-32-14.3-32-32v-128c0-17.7 14.3-32 32-32h56v-40h-104c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h280v-40h-72c-17.7 0-32-14.3-32-32v-128c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-72v40h280c8.8 0 16 7.2 16 16v16zM256 128h128v-64h-128v64zM192 448v-64h-96v64h96zM544 448v-64h-96v64h96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/network-wired.js
// module id = 1592
// module chunks = 0